<ion-grid class="ion-no-padding">
  <ion-row>
    <ion-col size="12" size-md="12" size-xl="4" class="ion-no-padding">
      <ion-item lines="none">{{ to.label }}</ion-item>
    </ion-col>
    @if (field.fieldGroup.length > 0) {
      <ion-col size="12" size-md="12" size-xl="8"
        class="ion-no-padding">
        <ion-item lines="none" class="noPadding">
          <ion-icon class="ion-no-padding; ion-no-margin" name="add-outline" (click)="add(-1)" slot="end">
          </ion-icon>
        </ion-item>
        @for (field of field.fieldGroup; track field; let i = $index) {
          <ion-item lines="none" class="noPadding">
            <formly-field slot="end" [field]="field"></formly-field>
            <ion-icon class="ion-no-padding; ion-no-margin" name="add-outline" (click)="add(field.key)" slot="end">
            </ion-icon>
            <ion-icon class="ion-no-padding; ion-no-margin" name="trash-outline" (click)="remove(i)" slot="end">
            </ion-icon>
          </ion-item>
        }
      </ion-col>
    } @else {
      <ion-col>
        <ion-item>
          <ion-icon name="add-outline" (click)="add()"></ion-icon>
        </ion-item>
      </ion-col>
    }
  </ion-row>
</ion-grid>
